var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#292929",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99913 13.0059L14.5891 13.0059L11.2891 16.2959C11.1008 16.4842 10.995 16.7396 10.995 17.0059C10.995 17.2722 11.1008 17.5276 11.2891 17.7159C11.4774 17.9042 11.7328 18.01 11.9991 18.01C12.2654 18.01 12.5208 17.9042 12.7091 17.7159L17.7091 12.7159C17.8002 12.6208 17.8715 12.5087 17.9191 12.3859C18.0191 12.1425 18.0191 11.8694 17.9191 11.6259C17.8715 11.5032 17.8002 11.391 17.7091 11.2959L12.7091 6.29592C12.6162 6.20219 12.5056 6.12779 12.3837 6.07703C12.2618 6.02626 12.1311 6.00012 11.9991 6.00012C11.8671 6.00012 11.7364 6.02626 11.6146 6.07703C11.4927 6.12779 11.3821 6.20219 11.2891 6.29592C11.1954 6.38888 11.121 6.49948 11.0702 6.62134C11.0195 6.7432 10.9933 6.87391 10.9933 7.00592C10.9933 7.13793 11.0195 7.26864 11.0702 7.39049C11.121 7.51235 11.1954 7.62295 11.2891 7.71592L14.5891 11.0059L6.99913 11.0059C6.73391 11.0059 6.47956 11.1113 6.29202 11.2988C6.10448 11.4863 5.99913 11.7407 5.99913 12.0059C5.99913 12.2711 6.10448 12.5255 6.29202 12.713C6.47956 12.9006 6.73391 13.0059 6.99913 13.0059Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.cac39e91af9a21173ad856329834cf08.svg";
export { ForwardRef as ReactComponent };